import { Injectable } from '@angular/core';
import { AjaxService } from '../../../services/ajax.service';
import { ViewScopeService } from '../../../services/view-scope.service';
import { LOAD_NOTI_FOR_FILE, RESOLVE_NOTI_FOR_FILE } from '../../../services/account-api.constants';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NotificationItem } from '../../../models/notification-item.model';

@Injectable({
	providedIn: 'root'
})
export class NotificationDialogService 
{
	constructor (private viewScopeService: ViewScopeService, private ajaxService: AjaxService){}

	public getFileNotifications(fileRecId: number): Observable<NotificationItem[]> {
		const apiEndpoint = this.ajaxService.getBaseOfApi() + LOAD_NOTI_FOR_FILE + fileRecId + '/' + this.viewScopeService.getCurrentOpertaingUserId().toString();

		return this.ajaxService.getData(apiEndpoint).pipe(
			map((response: any) => response as NotificationItem[]),
			catchError(error => {
				console.error(`Error fetching notifications for FileRecID ${fileRecId}:`, error);
				return of([]);
			})
		);
	}

	public updateFileNotification(FileNotificationRecID: number, isNotification: 0 | 1): Observable<Object> 
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + RESOLVE_NOTI_FOR_FILE;
		const payload = this.createPayload(FileNotificationRecID, isNotification);
		return this.ajaxService.updateObjectData(apiUrl, payload);
	}

	public resolveAllNotificationsForFile(fileRecId: number): Observable<NotificationItem[]> {
		return this.getFileNotifications(fileRecId).pipe(
			switchMap(notifications => {
				const unresolvedNotifications = notifications.filter(notification => notification.IsNotificationResolved !== 1);
				if (unresolvedNotifications.length === 0) {
					return of(notifications);
				}

				return forkJoin(unresolvedNotifications.map(notification =>
					this.updateFileNotification(notification.RecID, 1)
				)).pipe(
					map(() => notifications.map(notification => ({
						...notification,
						IsNotificationResolved: 1 as const
					})))
				);
			})
		);
	}


	private createPayload(recId: number, isNotification: 0 | 1): { FileNotificationRecID: number, IsNotificationResolved: 0 | 1, UserRecID: number } 
	{
		const payload = 
		{
			FileNotificationRecID: recId,
			IsNotificationResolved: isNotification,
			UserRecID: this.viewScopeService.getCurrentOpertaingUserId()
		};
		// For debugging/logging: justified JSON
		//console.log('Set contact main:', JSON.stringify(payload));
		return payload;
	}
}
